import { createAction } from '@reduxjs/toolkit';

import * as filtersConstants from './constants';
import type { FiltrationSuccess } from './types';

export const changeFilterAction = (payload) => ({
  type: filtersConstants.CHANGE_FILTER,
  payload,
});

export const clearFilterAction = (payload) => ({
  type: filtersConstants.CLEAR_FILTER,
  payload,
});

export const clearFiltersAction = () => ({
  type: filtersConstants.CLEAR_FILTERS,
});

export const setFiltersAction = (payload) => ({
  type: filtersConstants.SET_FILTERS,
  payload,
});

export const filtrationSuccessAction = createAction<FiltrationSuccess>(
  filtersConstants.FILTRATION_SUCCESS,
);
